import React, { Fragment } from 'react';
import './BrandColab.scss'
import { NavigateTo } from '../../Utilities';
import { AiFillPlayCircle } from 'react-icons/ai';



export default function BrandColab() {
    return (
        <Fragment>
            <div className='corners'>
                <div className='corners-border-btm' />
                <div className='colab-brands-container'>
                    <div className='colab-text'>
                        {/* <div className='mood-smile'>In the mood to smile</div> */}
                        {/* <div className='lets-talk' onClick={(event: any) => { */}
                        <div className='mood-smile' onClick={(event: any) => {
                            NavigateTo(event, "contact")
                        }}>
                            <div style={{ marginRight: "5%" }}>
                                Lets connect
                            </div>
                            <div>
                                <AiFillPlayCircle />
                            </div>
                        </div>
                    </div>
                    <div className="colab-brands">
                        {Array.from(Array(23), (e, index) => (
                            <div key={index} className="brand-logo">
                                <img src={`assets/images/brand_logos/${index + 1}.png`} alt={`${index}`} />
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </Fragment>
    );
};